import React from 'react';
import { ThemeProvider, createTheme } from '@mui/material/styles'; // Import ThemeProvider and createTheme
import Dialog from '@mui/material/Dialog';
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Typography from '@mui/material/Typography';
import 'react-dropzone-uploader/dist/styles.css';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import StepContent from '@mui/material/StepContent';
import Spinner from '../../UIComponents/Spinner/Spinner';
import MessageBox from '../../UIComponents/MessageBox/MessageBox';
import { styled } from '@mui/system';
import CheckIcon from '@mui/icons-material/Check';
import axios from 'axios';
import Cookie from 'js-cookie';
import { Config } from '../../config/config';

// Define your theme
const theme = createTheme();

const QontoConnector = styled('div')(({ theme }) => ({
  [`& .MuiStepConnector-alternativeLabel`]: {
    top: 10,
    left: `calc(-50% + ${theme.spacing(2)}px)`,
    right: `calc(50% + ${theme.spacing(2)}px)`,
  },
  [`& .MuiStepConnector-active`]: {
    '& .MuiStepConnector-line': {
      borderColor: '#784af4',
    },
  },
  [`& .MuiStepConnector-completed`]: {
    '& .MuiStepConnector-line': {
      borderColor: '#784af4',
    },
  },
  '& .MuiStepConnector-line': {
    borderColor: '#eaeaf0',
    borderTopWidth: 3,
    borderRadius: 1,
  },
}));

const QontoStepIconRoot = styled('div')(({ theme }) => ({
  color: '#eaeaf0',
  display: 'flex',
  height: 22,
  alignItems: 'center',
  ...(theme.transitions.create('transform', {
    duration: theme.transitions.duration.shortest,
  })),
}));

const QontoStepIconCircle = styled('div')(({ theme, active }) => ({
  width: 22,
  height: 22,
  borderRadius: '50%',
  backgroundColor: active ? '#784af4' : 'currentColor',
}));


const QontoStepIcon = ({ active, completed }) => {
  return (
    <QontoStepIconRoot>
      {completed ? (
        <CheckIcon sx={{ fontSize: 18, color: '#784af4', zIndex: 1 }} />
      ) : (
        <QontoStepIconCircle active={active} />

      )}
    </QontoStepIconRoot>
  );
};

function getSteps() {
  return ['Job Title Sheet', 'Fed ID Sheet'];
}

const UploadDocument = (props) => {
  const [open, setOpen] = React.useState(false);
  const [loading, setLoading] = React.useState(false);
  const [modalOpen, setModalOpen] = React.useState(false);
  const [message, setMessage] = React.useState('');
  const config = JSON.parse(Config);
  const [activeStep, setActiveStep] = React.useState(0);
  const steps = getSteps();
  const [selectedFile, setSelectedFile] = React.useState('');
  const [firstDocument, setFirstDocument] = React.useState('');
  const [secondDocument, setSecondDocument] = React.useState('');
  const [selectedFile1, setSelectedFile1] = React.useState('');

  const handleFile = (e) => {
    if (activeStep === 0) {
      setSelectedFile(e.target.files[0]);
    }
  };
  const handleFile1 = (e) => {
    if (activeStep === 1) {
      setSelectedFile1(e.target.files[0]);
    }
  };
  const handleClose = () => {
    setModalOpen(false);
    setMessage('');
  };
  const handleNext = (e) => {
    setLoading(true);

    if (selectedFile !== '') {
      let headers = {
        Authorization: 'Bearer ' + JSON.parse(Cookie.get('token')),
        'Access-Control-Allow-Origin': '*',
        'x-api-key': process.env.REACT_APP_X_API_KEY,
      };
      //Upload Doc
      const data = new FormData();
      data.append('file', selectedFile);

      axios
        .post(
          process.env.REACT_APP_UPLOAD_DOWNLOAD +
            config['api'] +
            '/uploadjobtitlemapping',
          data,
          {
            headers: headers,
          }
        )
        .then((response) => {
          setLoading(false);

          setFirstDocument(response.status);
          setActiveStep(1);
        })
        .catch(() => {
          setMessage('Unable to retrieve the data. Please try again later');
          setLoading(false);
          setModalOpen(true);
        });
    } else {
      setActiveStep((prevActiveStep) => prevActiveStep + 0);
      setLoading(false);
    }
  };
  const handleNext1 = () => {
    setLoading(true);
    if (selectedFile1 !== '') {
      let headers = {
        Authorization: 'Bearer ' + JSON.parse(Cookie.get('token')),
        'Access-Control-Allow-Origin': '*',
        'x-api-key': process.env.REACT_APP_X_API_KEY,
      };
      //Upload Doc
      const data = new FormData();
      data.append('file', selectedFile1);

      axios
        .post(
          process.env.REACT_APP_UPLOAD_DOWNLOAD +
            config['api'] +
            '/uploadfedid',
          data,
          {
            headers: headers,
          }
        )
        .then((response) => {
          setSecondDocument(response.status);
          setActiveStep((prevActiveStep) => prevActiveStep + 1);
          setLoading(false);
          props.getUploadedLog();
          setOpen(false);
        })
        .catch((error) => {
          setMessage('Unable to retrieve the data. Please try again later');

          setLoading(false);
          setModalOpen(true);
        });
    } else {
      setModalOpen(true);
      setMessage('Unable to retrieve the data. Please try again later');
    }
  };
  function getStepContent(step) {
    switch (step) {
      case 0:
        return (
          <form
            onSubmit={(event) => {
              event.preventDefault();
            }}
            className='form-horizontal '
            style={{ backgroundColor: '#eaf7fdcc' }}
            enctype='multipart/form-data'
          >
            <input
              className='uploadDocFile'
              type='file'
              onChange={handleFile}
              enctype='multipart/form-data'
              accept='application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
            />

            <div className='form-group'>
              {activeStep === 0 ? (
                <button
                  className='btn btn-secondary deca-btn-yellow a-update-email-alert'
                  onClick={handleNext}
                  style={{ float: 'right' }}
                  disabled={!selectedFile}
                >
                  Upload
                </button>
              ) : (
                ''
              )}
              <button
                className='btn btn-secondary deca-btn-orange a-update-email-alert'
                style={{ float: 'right' }}
                type='button'
                onClick={() => {
                  setActiveStep(1);
                  // setActiveStep((prevActiveStep) => prevActiveStep + 1);

                }}
              >
                Skip
              </button>
            </div>
          </form>
        );

      case 1:
        return (
          <form
            onSubmit={(event) => {
              event.preventDefault();
            }}
            className='form-horizontal '
            style={{ backgroundColor: '#eaf7fdcc' }}
          >
            <input
              enctype='multipart/form-data'
              className='uploadDocFile'
              type='file'
              onChange={handleFile1}
              accept='application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
            />

            <div className='form-group'>
              {activeStep === steps.length - 1 ? (
                <button
                  className='btn btn-secondary deca-btn-yellow a-update-email-alert'
                  onClick={handleNext1}
                  style={{ float: 'right' }}
                  disabled={!selectedFile1}
                >
                  Upload
                </button>
              ) : (
                ''
              )}
            </div>
          </form>
        );
      default:
        return 'Unknown step';
    }
  }

  const handleClickOpen = () => {
    setOpen(true);
    setActiveStep(0);
  };
  const handleClose1 = () => {
    setOpen(false);
  };

  return (
    <ThemeProvider theme={theme}>
      <div>
        <button
          variant='outlined'
          color='primary'
          type='button'
          className='btn btn-secondary deca-btn-yellow '
          style={{
            color: 'white',
            textDecoration: 'none',
          }}
          onClick={handleClickOpen}
        >
          Click Here to Upload
        </button>

        <Dialog
          onClose={handleClose1}
          aria-labelledby='customized-dialog-title'
          open={open}
          fullWidth={true}
          maxWidth='md'
        >
          {modalOpen ? (
            <MessageBox message={message} signout={false} onClose={handleClose} />
          ) : null}
          <DialogTitle id='customized-dialog-title' onClose={handleClose1}>
            <Typography variant='h6' component='p' sx={{fontSize:"1.5rem"}}>
              Upload Document
            </Typography>
            <IconButton
              aria-label='close'
              onClick={handleClose1}
              sx={{
                position: 'absolute',
                right: 8,
                top: 8,
                color: (theme) => theme.palette.grey[500],
              }}
            >
              <CloseIcon />
            </IconButton>
          </DialogTitle>
          <DialogContent dividers>
            <form
              className='form-horizontal '
              style={{ backgroundColor: '#eaf7fdcc' }}
            >
              <Stepper
                activeStep={activeStep}
                orientation='vertical'
                connector={<QontoConnector />}
              >
                {steps.map((label, index) => (
                  <Step key={label}>
                    <StepLabel StepIconComponent={QontoStepIcon}>
                      {label}
                    </StepLabel>
                    {loading ? (
                      <Spinner />
                    ) : (
                      <StepContent>
                        <Typography>{getStepContent(index)}</Typography>
                      </StepContent>
                    )}
                  </Step>
                ))}
              </Stepper>
            </form>
          </DialogContent>
        </Dialog>
      </div>
    </ThemeProvider>
  );
};

export default UploadDocument;
